module.exports = __webpack_public_path__ + "img/Maestro_logo.736f863e.png";